import axiosInstance from "../api";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";
import {
  GET_OTS,
  GET_BXP_OTS_BY_ID,
  GET_BXP_OTS_MINE,
  GET_PROJECT_OTS_MINE,
  GET_FILTERD_OTS,
  GET_BXP_ORDER,
  GET_MINE_BXP_ORDER,
  GET_BXP_THOGETHER1,
  GET_BXP_THOGETHER5,
  GET_BXP_THOGETHER4,
  GET_BXP_THOGETHER3,
  GET_BXP_THOGETHER2,
  GET_MINE_ACTIVE_BXP_LIST,
  GET_OTS_REQUEST_BY_ID,
} from "../constants";
import { getPostCounts } from "../posts/action";
import { getAuctionById } from "../auction/action";

export const getOTSList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`bxp`);
    if (response?.data?.status) {
      dispatch({ type: GET_OTS, getotslist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};
export const apiTest = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get("test");
    if (response?.data?.status) {
      dispatch({ type: GET_FILTERD_OTS, getfilterdots: response.data });
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const FilterOTSListings = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("bxp", data);
    if (response?.data?.status) {
      dispatch({ type: GET_FILTERD_OTS, getfilterdots: response.data });
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const getMineBXPOTSList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`bxp?is_mine=1`);
    if (response?.data?.status) {
      dispatch({
        type: GET_BXP_OTS_MINE,
        getmineotslist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getMineProductOTSList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`sale?is_mine=1`);
    if (response?.data?.status) {
      dispatch({
        type: GET_PROJECT_OTS_MINE,
        getmineproductotslist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const addOTS = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("bxp/create", data);
    if (response?.data?.status) {
      dispatch(getMineBXPOTSList());
      dispatch(getPostCounts(6));
      setLoading(false);
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const updateOTS = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("bxp/update", data);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getMineBXPOTSList());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    //urtoast(err.message, 2);
  }
};

export const getOTSById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`bxp/id?id=${id}`);
    if (response?.data?.status) {
      dispatch({ type: GET_BXP_OTS_BY_ID, getotsbyid: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const addtowishinOTSbyid = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`bxp/id?id=${id}&wishlist=1`);
    if (response?.data?.status) {
      dispatch(getOTSById(id));
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};
export const addtowishinActionbyid = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`auction/id?id=${id}&wishlist=1`);
    if (response?.data?.status) {
      dispatch(getAuctionById(id));
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getOTSByIdRequest = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `bxp/request/id?bxp_request_id=${id}`
    );
    if (response?.data?.status) {
      dispatch({ type: GET_BXP_OTS_BY_ID, getotsbyid: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const deleteOTS = (id, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.delete(`bxp/delete?id=${id}`);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getPostCounts(6));
      dispatch(getMineBXPOTSList());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    //urtoast(err.message, 2);
  }
};

export const bxpRequest = (data, setLoading, navigate) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("bxp/request/create", data);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);

      if (response?.data?.response) {
        setLoading(false);
        navigate(data?.url, {
          state: {
            orderdetails: {
              ...data?.state,
              bxp_request_id: response?.data?.response?.bxp_request?.id,
              bxp_request_milestone_id: response?.data?.response?.bxp_request?.milestones[0]?.id,
            },
          },
        });
        urtoast(response?.data?.response?.message, 1);
        // const data1 = {
        //   type: "9",
        //   bxp_request_id: response?.data?.response?.bxp_request?.id,
        // };
        // dispatch(payBXPAmount(data1));
      }
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const payBXPAmount = (data, navigate) => async (dispatch) => {

  const laung = localStorage.getItem("laung")
  try {
    const payload = { ...data, wallet: data?.wallet || 0 };
    const response = await axiosInstance.post("payment", payload);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      navigate(`/${laung}/packageddetails/${data.package_id}`);
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const updateBXPStatus = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("auction/bid/update", data);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const getMineBXPOrderList = (status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `bxp?is_mine=1&status=${status}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_MINE_BXP_ORDER,
        minebxporderlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};
export const getBXPOrderList = (status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`bxp?status=${status}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_BXP_ORDER,
        bxporderlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};


export const getOTSRequestById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`bxp/request/id?bxp_request_id=${id}`);
    if (response?.data?.status) {
      dispatch({ type: GET_OTS_REQUEST_BY_ID, otsrequestbyid: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const bxpAcceptReject = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("bxp/request/update", data);
    if (response?.data?.status) {
      dispatch(getBxpTogether1(1));
      if (data?.countapihitformyorder) {
        dispatch(getPostCounts(2));
        dispatch(getBxpTogether3(3));
      }
      else {
        dispatch(getPostCounts(7));
      }
      urtoast(response?.data?.response?.message, 1);
      return response?.data
    } else {
      urtoast(response?.data?.response?.message, 2);
      return response?.data
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const getBxpTogether1 = (status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`bxp/together?select_type=1`);
    if (response?.data?.status) {
      dispatch({
        type: GET_BXP_THOGETHER1,
        bxptogetherlist1: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getBxpTogether2 = (status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`bxp/together?select_type=2`);
    if (response?.data?.status) {
      dispatch({
        type: GET_BXP_THOGETHER2,
        bxptogetherlist2: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getBxpTogether3 = (status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`bxp/together?select_type=3`);
    if (response?.data?.status) {
      dispatch({
        type: GET_BXP_THOGETHER3,
        bxptogetherlist3: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getBxpTogether4 = (status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`bxp/together?select_type=4`);
    if (response?.data?.status) {
      dispatch({
        type: GET_BXP_THOGETHER4,
        bxptogetherlist4: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getBxpTogether5 = (status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`bxp/together?select_type=5`);
    if (response?.data?.status) {
      dispatch({
        type: GET_BXP_THOGETHER5,
        bxptogetherlist5: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getMineActiveBXPList = (status, is_mine = 0) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `post?is_bxp=1&status=${status}&is_mine=${is_mine}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_MINE_ACTIVE_BXP_LIST,
        mineactivebxplist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};